import type { ISelectedUninstallReason, IUninstallConfirm } from '../types';

import { UNINSTALL_MODAL_STEPS } from '../constants';
import { create } from 'zustand';

interface UninstallStoreState {
  currentStep: number;
  selectedUninstallReason: ISelectedUninstallReason;
  confirm: IUninstallConfirm;
  isLoadingCleanup: boolean;
}

interface UninstallStoreActions {
  nextStep: () => void;
  previousStep: () => void;
  setSelectedUninstallReason: (reason: ISelectedUninstallReason) => void;
  setConfirm: (confirm: IUninstallConfirm) => void;
  setIsLoadingCleanup: (isLoadingCleanup: boolean) => void;
  reset: () => void;
}

export const INITIAL_STATE_UNINSTALL: UninstallStoreState = {
  currentStep: UNINSTALL_MODAL_STEPS.UNINSTALL_REASON,
  selectedUninstallReason: { value: '', detail: { value: '' } },
  confirm: { deleteAnalytics: false, billingCycle: false },
  isLoadingCleanup: false,
};

export const useUninstallStore = create<UninstallStoreState & UninstallStoreActions>()((set) => ({
  ...INITIAL_STATE_UNINSTALL,
  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  previousStep: () => set((state) => ({ currentStep: state.currentStep - 1 })),
  setSelectedUninstallReason: (reason: ISelectedUninstallReason) =>
    set({ selectedUninstallReason: reason }),
  setConfirm: (confirm: IUninstallConfirm) => set({ confirm }),
  setIsLoadingCleanup: (isLoadingCleanup: boolean) => set({ isLoadingCleanup }),
  reset: () => set(INITIAL_STATE_UNINSTALL),
}));
